import { render, staticRenderFns } from "./PopupReformationPlan.vue?vue&type=template&id=5d4c150a&scoped=true"
import script from "./PopupReformationPlan.vue?vue&type=script&lang=js"
export * from "./PopupReformationPlan.vue?vue&type=script&lang=js"
import style0 from "./PopupReformationPlan.vue?vue&type=style&index=0&id=5d4c150a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c150a",
  null
  
)

export default component.exports